import { inject, Injectable } from '@angular/core';
import { assert } from '@sama/js-core';
import { isVideoOutput } from '../../../../../cross-team-shared/misc-utils/output-utils';
import { TaskWorkspaceStore } from '../../../state/task-workspace-store';

@Injectable()
export class SplitViewInitializationService {
  store = inject(TaskWorkspaceStore);

  turnSplitViewOn() {
    this.store('splitViewOutputName').set(this.getDefaultSplitViewName());
  }

  private getDefaultSplitViewName() {
    const firstVideoOutput = this.store
      .state()
      .outputsByDisplayOrder.filter(isVideoOutput)[0];
    assert(
      firstVideoOutput,
      'split view should only be turned on when there is at least one video output',
    );
    return firstVideoOutput.name;
  }
}
